import { Injectable } from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {EmployerBilledLoanees} from "../../bills/Models/EmployerBilledLoanees";
import {RegisterNewEmployeesRequest} from "../Models/Requests/RegisterNewEmployeesRequest";
import {SubmitNewStaffObject} from "../Models/SubmitNewStaffObject";
import {EmployerStaffSummaryView} from "../../../Shared/Models/iLMS/EmployerStaffSummaryView";

@Injectable({
  providedIn: 'root'
})
export class EmployerStaffService {
  public employer_portal_service_url: string = environment.employer_portal_service_url;
  constructor(private http: HttpClient) { }

  public getAllEmployerStaffDetails(employer_id: number): Observable<EmployerStaffSummaryView[]> {
    const params: HttpParams = new HttpParams().set('employer_id', employer_id);
    return this.http.get<EmployerStaffSummaryView[]>(`${this.employer_portal_service_url}/employer-staff/employer-staff/`, {params});
  }

  public getAllEmployeesBilledForStaffAddition(employer_id: number): Observable<EmployerBilledLoanees[]> {
    const params: HttpParams = new HttpParams().set('employer_id', employer_id);
    return this.http.get<EmployerBilledLoanees[]>(`${this.employer_portal_service_url}/employer-staff/billed-loanees-for-staff-addition/`, {params});
  }

  public registerNewStaff(req: RegisterNewEmployeesRequest): Observable<SubmitNewStaffObject> {
    return this.http.post<SubmitNewStaffObject>(`${this.employer_portal_service_url}/employer-staff/employer-staff/`, req);
  }

  public removeStaffFromCurrentEmployer(employer_id: number, loanee_id): Observable<SubmitNewStaffObject> {
    const  params: HttpParams = new HttpParams().set('employer_id', employer_id).set('loanee_id', loanee_id);
    return this.http.delete<SubmitNewStaffObject>(`${this.employer_portal_service_url}/employer-staff/employer-staff/`, {params});
  }

  public updateEmployee(req: SubmitNewStaffObject): Observable<SubmitNewStaffObject> {
    return this.http.patch<SubmitNewStaffObject>(`${this.employer_portal_service_url}/employer-staff/employer-staff/`, req);
  }


}
